import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import StorageHelper from '@/Utility/StorageHelper';

export default class EnhancedTabGroupBoxViewModel extends ControlViewModel {

    public selectedIndex: KnockoutObservable<number>;
    public onSelectedIndexChanged: (index: number) => void;
    private name: string;
    public _refreshTrigger: KnockoutObservable<boolean>;
    
    public constructor(protected params: any) {  
        super(params); 

        this.name = this.paramOrDefault(params.name, '');
        let storageHelperKey = 'TabGroupBoxSelectedIndex_' + this.name;
        let selectedIndexBind = StorageHelper.bind(storageHelperKey, 0);
        this.addComputed(selectedIndexBind);
        this.selectedIndex = selectedIndexBind;

        this.onSelectedIndexChanged = this.handlerOrDefault(params.onSelectedIndexChanged);
        this.defineSubscription(this.selectedIndex, this.onSelectedIndexChanged);
        // Initiales Triggern um Zeichnen auszulösen
        this.onSelectedIndexChanged(this.selectedIndex());
        this._refreshTrigger = this.observableOrDefault(false).extend({ notify: 'always' })
    }

    public refresh(): void {
        this._refreshTrigger(true);
    }
}

ComponentManager.setViewModel('EnhancedTabGroupBoxViewModel', EnhancedTabGroupBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');